import ScrollPane from "../../../../../shared/lib/html5-software-library/src/ranj/components/scrolling/ScrollPane";

export default class PuzzleScrollPane extends ScrollPane {

    constructor(viewport, hScrollBarSkin, vScrollBarSkin, contentContainer, contentMask, dragEnabled, scrollWheelEnabled, scrollBarPadding, stage) {
        super(viewport, hScrollBarSkin, vScrollBarSkin, contentContainer, contentMask, dragEnabled, scrollWheelEnabled, scrollBarPadding, stage);

        this._dragOffset = 0;
        this._dragging = false;
        this.addEventListener(ScrollPane.SCROLL_STARTED, this._handleScrollStarted.bind(this));
        this.addEventListener(ScrollPane.SCROLL_ENDED, this._handleScrollEnded.bind(this));
    }

    _handleScrollStarted() {
        this._dragX = this.getX();
        this._dragY = this.getY();
        this._dragging = true;
    }

    _handleScrollEnded() {
        this._dragX = this.getX();
        this._dragY = this.getY();
        this._dragging = false;
    }

    get dragging() {
        return this._dragging;
    }

    dispatchPositionUpdate() {
        if (this._scrollStarted) {
            const x = this.getX(), y = this.getY();
            this._dragOffset = Math.sqrt(Math.pow(this._dragX - x, 2), Math.pow(this._dragY - y, 2));
            this._dragX = x;
            this._dragY = y;
        }
        this.dispatchEvent(ScrollPane.SCROLL_POSITION_UPDATE, { dragging: this._scrollStarted, offset: this._dragOffset });
    }

    _setupBackgroundDragging() {
        //do nothing, just eclipse super method
    }

    set dragEnabled(value) {
        this._dragEnabled = value;
        this._contentContainer.removeEventListener("mousedown", this._onMouseDownBound, true);
        if (value) {
            this._contentContainer.addEventListener("mousedown", this._onMouseDownBound, true);
        }
    }

    get dragEnabled() {
        return this._dragEnabled;
    }
}
